import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useSubtleIcon } from 'kineticUtils';

import { DrawerMenuItemProps } from './types';

const useDrawerMenuItemStyles = makeStyles(({ spacing, palette }) => {
  const { subtleIcon } = useSubtleIcon(palette);
  return createStyles({
    subtleIcon,
    iconWrapper: {
      marginLeft: 'auto',
      display: 'inline-flex',
      visibility: ({ showIconOnHover }: DrawerMenuItemProps) =>
        showIconOnHover ? 'hidden' : 'visible',
    },

    menuItem: {
      padding: `${spacing(2)}`,
      cursor: ({ to, onClick }: DrawerMenuItemProps) => (to || onClick ? 'cursor' : 'auto'),
      '& > svg': {
        marginLeft: 'auto',
        display: 'inline-flex',
      },
      '& > button': {
        '&:hover': {
          color: palette.text.primary,
        },
      },
      '&:hover': {
        backgroundColor: ({ to, onClick }: DrawerMenuItemProps) =>
          to || onClick ? palette.grey[400] : 'transparent',
        '& > $iconWrapper': {
          visibility: 'visible' as const,
        },
      },
    },
    selected: {
      backgroundColor: palette.grey[500],
    },
    disabledLink: {
      color: palette.text.disabled,
    },
    drawerList: {
      padding: 0,
      margin: 0,
    },
  });
});

export default useDrawerMenuItemStyles;
